'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface ResourceCardProps {
  title: string;
  description: string;
  category: string;
  image: string;
  alt: string;
  downloadUrl: string;
  fileSize: string;
  fileType: string;
  downloads: number;
}

export default function ResourceCard({
  title,
  description,
  category,
  image,
  alt,
  downloadUrl,
  fileSize,
  fileType,
  downloads,
}: ResourceCardProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const handleDownload = () => {
    if (!isHydrated) return;
    console.log(`Downloading: ${downloadUrl}`);
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-brand transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {category}
          </span>
        </div>
      </div>
      
      <div className="p-5">
        <h3 className="text-lg font-semibold text-text-primary mb-2 line-clamp-2 group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="text-sm text-text-secondary mb-4 line-clamp-3">
          {description}
        </p>
        
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center space-x-4 text-xs text-text-secondary">
            <span className="flex items-center space-x-1">
              <Icon name="DocumentTextIcon" size={16} />
              <span>{fileType}</span>
            </span>
            <span>{fileSize}</span>
            <span className="flex items-center space-x-1">
              <Icon name="ArrowDownTrayIcon" size={16} />
              <span>{downloads.toLocaleString()}</span>
            </span>
          </div>
          
          <button
            onClick={handleDownload}
            disabled={!isHydrated}
            className="flex items-center space-x-1 px-4 py-2 bg-primary text-primary-foreground text-sm font-semibold rounded-md hover:bg-secondary transition-colors disabled:opacity-50"
          >
            <Icon name="ArrowDownTrayIcon" size={16} />
            <span>Download</span>
          </button>
        </div>
      </div>
    </div>
  );
}